var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Select from 'shared-assets/components/Elements/Select';
import states from './states';
var StateSelect = function (props) { return (React.createElement(Select, __assign({ defaultValue: "" }, props, { onChange: function (event) {
        if (props === null || props === void 0 ? void 0 : props.onChange) {
            props.onChange(event);
        }
    } }),
    React.createElement("option", { disabled: true, value: "" }, "Select State"),
    states.map(function (state) { return (React.createElement("option", { key: state.code, value: state.code }, state.name)); }))); };
export default StateSelect;
